var WorkFlowStepWarningController = /** @class */ (function () {
    /*@ngInject*/
    function WorkFlowStepWarningController($rootScope, companyService, jobService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.companyService = companyService;
        this.jobService = jobService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    WorkFlowStepWarningController.prototype.$onInit = function () {
        //flags
        this.isDetailsFetched = false;
        this.showDetailsFlag = false;
        this.requisitions = [];
        this.clientOrBus = [];
        if (this.stepName.includes("Verification")) {
            this.stepName = "Verification";
        }
        this.stepDetails = {
            companyId: this.companyId,
            workflowStep: this.stepName
        };
        if (this.context == 'clientOrBu') {
            this.stepDetails.clientOrBuId = this.clientOrBuId;
        }
        this.getDetails();
    };
    WorkFlowStepWarningController.prototype.getDetails = function () {
        if (this.context == 'clientOrBu') {
            this._getRequisitions();
        }
        else {
            this._getClientsOrBus();
        }
    };
    WorkFlowStepWarningController.prototype._getRequisitions = function () {
        var _this = this;
        this.jobService.getRequisitionsInWorkFlowStep(this.stepDetails, function (data) {
            _this.isDetailsFetched = true;
            _this.requisitions = data;
            _this._setCountInMessage(_this.requisitions.length);
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    WorkFlowStepWarningController.prototype._getClientsOrBus = function () {
        var _this = this;
        this.companyService.getWorkFlowStepClientOrBuDetails(this.stepDetails, function (data) {
            _this.isDetailsFetched = true;
            _this.clientOrBus = data;
            _this._setCountInMessage(_this.clientOrBus.length);
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    WorkFlowStepWarningController.prototype._setCountInMessage = function (count) {
        var wordsInMessage = this.message.split(' ');
        wordsInMessage[0] = count;
        this.message = wordsInMessage.join(' ');
    };
    WorkFlowStepWarningController.prototype.showDetails = function () {
        this.showDetailsFlag = true;
    };
    WorkFlowStepWarningController.prototype.close = function () {
        if (this.successCallback) {
            this.successCallback();
        }
    };
    return WorkFlowStepWarningController;
}());
WorkFlowStepWarningController.$inject = ['$rootScope', 'companyService', 'jobService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './work-flow-step-warning.html';
import * as TEMPLATE from 'raw-loader!./work-flow-step-warning.html';
export var WorkFlowStepWarningComponent = {
    selector: 'workFlowStepWarning',
    component: {
        bindings: {
            context: '@',
            companyId: '@',
            clientOrBuId: '@',
            message: '@',
            stepName: '@',
            successCallback: '&',
        },
        controller: WorkFlowStepWarningController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/workFlowStepWarning/work-flow-step-warning.html'
    }
};
//# sourceMappingURL=work-flow-step-warning.component.js.map